﻿import { required, minLength, numeric } from 'vuelidate/lib/validators'
import { getQueryString } from '../../../../js/shared/utils/ajax';
import { ajaxPost } from '../../utils/ajax';


export default {
    name: 'authentication',
    template: '#authentication-template',
    created() {

    },
    mounted() {
        this.$watch('$v.model.$invalid',
        () => {
            this.updateValidState();
        });
        this.updateValidState();
        this.model = this.viewmodel;
        if (this.model.clientRefresh) {
            this.$v.model.$touch();
        }

    this.translate();
    },
    props: ['blockid', 'viewmodel'],
    data: () => ({
        model: {    
        },
        pageLoaded: true,
        translation: {}
    }),
    validations: {
        model: {
            cvr: {
                required,
                numeric,
                hasRightLength (value) {
                    if (value !== null && value !== "undefined" && value !== undefined) {
                        if (value.length === 8) {
                            return true;
                        }
                        return false;
                    }
                    return false;
                }
            }
        }
    },
    methods: {
        updateValidState(){
            this.$store.dispatch('updateValidState', { invalid: this.$v.model.$invalid, blockId: this.blockid });
        },
        invalidate() {
            this.pageLoaded = false;
        },
        translate() {
            this.createTranslations();
            var validationElement = document.getElementById("cvrInvalidMessage");
            if (validationElement.innerText !== "") {
                validationElement.innerText = this.translation[validationElement.innerText];
            }
        },
        createTranslations() {
            this.translation = {
                "Cookie missing": this.model.currentBlock.errorMessageCvrInvalid,
                "Cvr missing": this.model.currentBlock.errorMessageCvrInvalid,
                "Cvr does not match": this.model.currentBlock.errorMessageCvrInvalid,
                "Cvr locked": this.model.currentBlock.errorMessageCvrLocked
                }
            }
    },
    ready: function() {
        
    }    
}